import { OpenItemsActionEnum } from "@enums/openItemsActionEnum.enum";

export class DeletePricingRequest {
    openItemsAction: OpenItemsActionEnum;
    shouldKeepAuth: boolean;
}
